export enum FilterType {
  AVAILABILITIES = 'AVAILABILITIES',
  APPS = 'APPS',
  BOOKINGS = 'BOOKINGS',
  CLIENTS = 'CLIENTS',
  MESSAGES = 'MESSAGES',
  SERVICES = 'SERVICES',
  SUGGESTIONS = 'SUGGESTIONS',
  TRIPS = 'TRIPS',
  USERS = 'USERS',
  VEHICLES = 'VEHICLES',
}
